import React from 'react'
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { ReactNode } from "react";
import { ReactComponent as DraggableIcon } from '../../../../../assets/draggable-icon.svg';

interface SortableItemProps {
    id: string;
    children: ReactNode;
    isDraggable?: boolean;
}

export const SortableItem = ({ id, children, isDraggable }: SortableItemProps) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDraggable ? 1 : 0.5,
        cursor: isDraggable ? 'grabbing' : 'not-allowed',
        background: 'white'
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} >
            <div className='c-extended-report-card'>
                <div
                    className='drag-handle'
                    {...listeners}
                    style={
                        {
                            cursor: isDraggable ? "grab" : "not-allowed",
                            padding: "0 8px",
                            userSelect: "none",
                        }
                    }>
                    <span style={{ fontSize: "1.5rem" }}><DraggableIcon /></span>
                </div>
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
};